



















import Vue from 'vue';
import Icon from '../Icon';

export default Vue.extend({
  components: { Icon },
  props: {
    isVisited: {
      type: Boolean,
      default: false,
    },
    isCurrent: {
      type: Boolean,
      default: false,
    },
    position: {
      type: Number,
      required: true,
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    cssVars() {
      return {
        '--position-element-size': this.small ? '32px' : '40px',
        '--icon-margin': this.small ? '6px' : '10px',
      };
    },
  },
});
